<button class="btn floating-button" placement="left" [ngbTooltip]="'Contactar a Soporte'" (click)="soporteLubriKuv()"
    @rotateScaleIn>
    <i class="fa-brands fa-whatsapp pb-1"></i>
</button>